export default __webpack_public_path__ + "static/media/restore.2bfb4968.svg";